import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { DubaiPin } from "../../../../app-constants";
import FaqComponents from "../../components/common/faq";

const faqs = [
  {
    question:
      "Why should I invest in custom software development when I can purchase monthly subscriptions to commercial software?",
    answer: `<p>Businesses opt for custom software development primarily due to the following two reasons:</p>
        <ul>
            <li> Either the existing software they use has limitations or flaws.</li>
            <li>Or the subscription price of the software they use is breaking their bank</li>
        </ul>
        <p>The first reason is obvious, as no business wants to experience limitations in its workflow. Apparently, the second reason doesn’t make sense, as any credible custom software development company in Dubai would charge a substantial amount to build their software. However, some software subscriptions are extremely expensive and can eventually empty your bank. Thus, most businesses prefer building custom software of their own instead of perpetually buying ridiculously expensive software subscriptions.</p>`,
  },
  {
    question:
      "What are the primary differences between custom software and commercial software?",
    answer: `<p>The primary difference between custom software and commercial software is that custom software is tailor-made to address specific problems or concerns of a particular business, while commercial software is designed keeping general business needs in mind.</p>`,
  },
  {
    question: "What is the average cost of building custom software in Dubai?",
    answer: `<p>The cost of custom software development primarily depends on the following three factors:</p>
        <ul>
                 <li>The geographical location of the software development company</li>
                 <li>Nature of the project</li>
                 <li>Project deadline</li>
             </ul>
           <p>The average cost of custom software development in Dubai ranges from ABC to ABC. However, the cost is influenced substantially by the development company you partner with. The average development price quoted by a software development company UAE will be closer to the price quoted in Qatar or Bahrain but will be significantly lower than the average development price in the USA. You can use our software development cost calculator to get better and more accurate cost estimates.</p>  
        `,
  },
  {
    question: "How do I know if my business needs custom software?",
    answer: `<p>If your business is facing workflow obstacles and no commercial software is available to address those concerns, you should opt for building custom software to optimize the workflow.</p>
        <p>You should consider building a custom software if:</p>
        <ul>
            <li>Your business is performing well and growing at an exponential rate.</li>
            <li>Your monthly software subscription costs are breaking the bank.</li>
            <li>You can optimize efficiency and reduce workflow limitations in the long run.</li>
        </ul>
        <p>If any of the above conditions is true in your case, conduct interviews with potential candidates for custom software development in Dubai and kickstart your development project.</p>
   `,
  },
  {
    question:
      "Can I build custom software and offer it on the monthly subscription-based model to others?",
    answer: `<p>Yes, there are thousands of SaaS (software as a service) companies offering subscription-based software services. Canva, Slack, Asana, Trello, SalesForce, Veeva, etc., are among the top SaaS companies that you can take inspiration from for your custom software.</p>
        <p>Find your niche, create a software development roadmap, plan monetization strategies, and hire a software development company Dubai team to kickstart your software development project.</p>
  `,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col xs={12} md={12} lg={8} xl={7} xxl={7} className="services_faqs">
            <FaqComponents faqs={faqs} />
          </Col>
          <Col xs={12} md={12} lg={4} xl={4} xxl={4} className="offset-xl-1">
            <div className="map_loc">{DubaiPin}</div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
